var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.504,
    height: 12.502,
    viewBox: "0 0 12.504 12.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_edit",
    transform: "translate(-50 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19869",
    "data-name": "Group 19869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35332",
    "data-name": "Path 35332",
    d: "M11.713.793a2.714,2.714,0,0,0-3.833,0L.143,8.53A.49.49,0,0,0,0,8.872H0v3.142a.489.489,0,0,0,.489.489H3.631a.491.491,0,0,0,.345-.143l7.737-7.737a2.714,2.714,0,0,0,0-3.83ZM.977,11.529V10.055l1.474,1.474Zm2.654-.2L1.179,8.875l6.1-6.1.88.88L4.883,6.932a.489.489,0,1,0,.691.691L8.855,4.342l.88.88Zm7.391-7.391-.6.6L7.975,2.08l.6-.6a1.733,1.733,0,1,1,2.451,2.452Z",
    transform: "translate(50)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.558ae81248b5e98e8623f8dffb48d1e4.svg";
export { ForwardRef as ReactComponent };